import {
  Dialog,
  Typography,
  Button,
  CircularProgress,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
} from '@quillbot/design-system';
import { useState } from 'react';
import Firestore from 'src/authentication/handlers/firestore';
import { EmailVerificationStatus } from 'src/authentication/models/store';
import { Close } from '@mui/icons-material';
import Track from 'src/authentication/handlers/track';

interface IProps {
  isVisible: boolean;
  handleClose: Function;
  handleSuccess: Function;
}

const CloseCTA = styled(IconButton)`
  && {
    margin-top: -0.7em;
    opacity: 0.7;
  }
`;

const StyledMaterialTitle = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;

  && {
    margin-bottom: -1em;
    padding-right: 0;
  }

  button {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

function EmailVerifiedDialog({ isVisible, handleClose, handleSuccess }: IProps) {
  const handleDialogClose = () => {
    setVerifyStatus(EmailVerificationStatus.NOT_VERIFIED);
    handleClose();
  };
  const [verifyStatus, setVerifyStatus] = useState<EmailVerificationStatus>(
    EmailVerificationStatus.NOT_VERIFIED
  );
  const verifyUserEmail = async () => {
    setVerifyStatus(EmailVerificationStatus.VERIFYING);
    try {
      await Firestore.getInstance().sendEmailVerification('/upgrade');
      setVerifyStatus(EmailVerificationStatus.EMAIL_SENT);
    } catch (error) {
      Track.verifyEmailFailed();
      setVerifyStatus(EmailVerificationStatus.EMAIL_FAILED);
    }
  };

  return (
    <Dialog
      maxWidth="xs"
      onClose={handleDialogClose}
      aria-labelledby="customized-dialog-title"
      open={isVisible}
    >
      <StyledMaterialTitle>
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          Verify Your Email
        </Typography>
        <CloseCTA
          aria-label="close"
          style={{ width: '45px', height: '45px', maxWidth: '45px' }}
          onClick={handleDialogClose}
        >
          <Close />
        </CloseCTA>
      </StyledMaterialTitle>
      <DialogContent style={{ padding: '20px 24px 8px 24px' }}>
        <Typography gutterBottom variant="body1" style={{ marginBottom: '15px' }}>
          Please verify your email to continue
        </Typography>
        {(() => {
          switch (verifyStatus) {
            case EmailVerificationStatus.EMAIL_SENT:
              return (
                <Typography variant="body2" color="primary">
                  Verification link sent successfully, please check your email
                </Typography>
              );
            case EmailVerificationStatus.EMAIL_FAILED:
              return (
                <Typography variant="body2" color="error">
                  Something went wrong, please contact support
                </Typography>
              );
            default:
              return <div />;
          }
        })()}
      </DialogContent>
      <DialogActions>
        {(() => {
          switch (verifyStatus) {
            case EmailVerificationStatus.NOT_VERIFIED:
              return (
                <Button variant="contained" color="primary" onClick={verifyUserEmail}>
                  Resend Verification Email
                </Button>
              );
            case EmailVerificationStatus.VERIFYING:
              return <CircularProgress size="36px" />;
            case EmailVerificationStatus.EMAIL_SENT:
              return (
                <Button variant="contained" color="primary" disabled>
                  Email Sent
                </Button>
              );
            case EmailVerificationStatus.EMAIL_FAILED:
              return (
                <Button variant="contained" color="primary" disabled>
                  Resend Verification Email
                </Button>
              );
            default:
              return <div />;
          }
        })()}
      </DialogActions>
    </Dialog>
  );
}
export default EmailVerifiedDialog;
